import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DatePipe } from '@angular/common';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/services/common.service';
declare var $;
declare const copyToClipboard: any;


@Component({
  selector: 'app-connectivity',
  templateUrl: './connectivity.component.html',
  styleUrls: ['./connectivity.component.scss']
})
export class ConnectivityComponent {
  @Input() interfaceData: any;
  @Output() filecountemit = new EventEmitter<any>();
  category: any;
  pipeLineDetails = {}
  sequence: any[] = []
  connseqdatalist: any[] = []
  pendingfilecount: number = 0
  pendingfiledate: any = ''
  DiagnosticList: any[] = []
  ishide: boolean = true
  selectedSeqName: string;
  showdiagnostics: boolean;
  seqdataarr: any[] = [];
  jobid: any[] = [];
  uniqueId:any;
  data1 = [{ "Name": "VA-PushJob", "Data": [{ "Name": "agent.id", "Value": "806FA690-820A-4774-A9DB-88F28FF6FBF7" }, { "Name": "api.key", "Value": "B3E1940A-1464-426A-83AD-0B36411DE9C5" }, { "Name": "case.url", "Value": "https://lisapiservices.vitalaxis.com/api/v2/GetOutboundXML" }, { "Name": "config.url", "Value": "https://config.vitalaxis.net/api/config/v2/getconfig" }, { "Name": "log.status", "Value": "New,Processing" }, { "Name": "master.type", "Value": "VitalCore" }, { "Name": "message.type", "Value": "Results,BAR,DFT,Orders,VCDFT,DFTResults" }, { "Name": "push.type", "Value": "Rest" }, { "Name": "recordsPerRun", "Value": "1000" }, { "Name": "retryAttempts", "Value": "3" }, { "Name": "nextRetryDuration", "Value": "5" }, { "Name": "failureHttpStatusCodes", "Value": "404403" }, { "Name": "maxFailureCount", "Value": "3" }, { "Name": "Description", "Value": " " }], "status": "default" }, { "Name": "VA-HUB", "Data": [{ "Name": "RouteId", "Value": "149D0695-8F35-432C-BDB6-5FCEE7F13E47" }, { "Name": "SourceAgent", "Value": "18E92059-2569-04BB-49DC-3BBA747C5A6A" }, { "Name": "LastTransactionDate", "Value": "12/22/2023" }, { "Name": "Messagetype", "Value": "result" }, { "Name": "Direction", "Value": "Outbound" }, { "Name": "Status", "Value": "active" }, { "Name": "Description", "Value": "Case_360_D.LEC.result.OutBound.academic urology" }], "status": "Failed" }, { "Name": "VA-FTP", "Data": [{ "Name": "agentId", "Value": "18E92059-2569-04BB-49DC-3BBA747C5A6A" }, { "Name": "connectionType", "Value": "FTP" }, { "Name": "host", "Value": "111.93.235.19" }, { "Name": "port", "Value": "984" }, { "Name": "server", "Value": "111.93.235.19" }, { "Name": "userName", "Value": "---1595" }, { "Name": "password", "Value": "I3@esgmokd" }, { "Name": "remotePath", "Value": "//Case_360_D.LEC.result.OutBound.academic urology/Live/result/Outbound/" }, { "Name": "sourcePath", "Value": "\\\\192.168.3.50\\crbrfsftp\\LIS\\Case_360_D.LEC.result.OutBound.academic urology\\Live\\result\\Outbound\\" }, { "Name": "archivePath", "Value": "\\\\192.168.3.50\\crbrfsftp\\LIS\\Case_360_D.LEC.result.OutBound.academic urology\\Live\\result\\Outbound\\archive\\" }, { "Name": "progressPath", "Value": "\\\\192.168.3.50\\crbrfsftp\\LIS\\Case_360_D.LEC.result.OutBound.academic urology\\Live\\result\\Outbound\\progress\\" }, { "Name": "errorPath", "Value": "\\\\192.168.3.50\\crbrfsftp\\LIS\\Case_360_D.LEC.result.OutBound.academic urology\\Live\\result\\Outbound\\error\\" }, { "Name": "ackPath", "Value": null }, { "Name": "ignorePath", "Value": null }, { "Name": "Description", "Value": "Case_360_D.LEC.result.OutBound.academic urology" }], "status": "Failed" }]
  data2 = [{ "Header": "VA-PushJob", "SequenceNumber": 1, "LableValue": [], "status": "default" }, { "Header": "VA-HUB", "SequenceNumber": 2, "LableValue": [{ "DisplayName": "Last Successful Transaction", "labelName": "LastTransMessage", "type": "AutoCheck", "status": false, "lasttransdate": "", "folderstructure": "", "missingfolder": "", "permissions": null, "count": 0 }, { "DisplayName": "Message API response", "labelName": "MessageAPI", "type": "AutoCheck", "status": true, "lasttransdate": "", "folderstructure": "", "missingfolder": "", "permissions": null, "count": 0 }, { "DisplayName": "File API response", "labelName": "FileAPI", "type": "AutoCheck", "status": true, "lasttransdate": "", "folderstructure": "", "missingfolder": "", "permissions": null, "count": 0 }, { "DisplayName": "Processor API response", "labelName": "ProcessorAPI", "type": "AutoCheck", "status": true, "lasttransdate": "", "folderstructure": "", "missingfolder": "", "permissions": null, "count": 0 }, { "DisplayName": "Customer API response", "labelName": "CustomerAPI", "type": "AutoCheck", "status": false, "lasttransdate": "", "folderstructure": "", "missingfolder": "", "permissions": null, "count": 0 }, { "DisplayName": "Azure DB Health - DTU Capacity", "labelName": "", "type": "ManualCheck", "status": false, "lasttransdate": "", "folderstructure": "", "missingfolder": "", "permissions": null, "count": 0 }, { "DisplayName": "W700application Status", "labelName": "W700applicationStatus", "type": "AutoCheck", "status": true, "lasttransdate": "", "folderstructure": "", "missingfolder": "", "permissions": null, "count": 0 }, { "DisplayName": "W700application Effective To Time", "labelName": "W700applicationEffectiveToTime", "type": "AutoCheck", "status": true, "lasttransdate": "", "folderstructure": "", "missingfolder": "", "permissions": null, "count": 0 }, { "DisplayName": "W700application Service Start Time", "labelName": "W700applicationServiceStartTime", "type": "AutoCheck", "status": true, "lasttransdate": "", "folderstructure": "", "missingfolder": "", "permissions": null, "count": 0 }, { "DisplayName": "W700application Matching W700Job", "labelName": "W700applicationMatchingW700Job", "type": "AutoCheck", "status": true, "lasttransdate": "", "folderstructure": "", "missingfolder": "", "permissions": null, "count": 0 }, { "DisplayName": "W700Jobs Status", "labelName": "W700JobsStatus", "type": "AutoCheck", "status": true, "lasttransdate": "", "folderstructure": "", "missingfolder": "", "permissions": null, "count": 0 }, { "DisplayName": "W700Jobs Locked", "labelName": "W700JobsLocked", "type": "AutoCheck", "status": true, "lasttransdate": "", "folderstructure": "", "missingfolder": "", "permissions": null, "count": 0 }, { "DisplayName": "W700Jobs Last Updated Time", "labelName": "W700JobsLastUpdateTime", "type": "AutoCheck", "status": true, "lasttransdate": "", "folderstructure": "", "missingfolder": "", "permissions": null, "count": 0 }, { "DisplayName": "W700Jobs Matching Properties", "labelName": "W700JobsMatchingProperties", "type": "AutoCheck", "status": true, "lasttransdate": "", "folderstructure": "", "missingfolder": "", "permissions": null, "count": 0 }, { "DisplayName": "W700JobProperties AllProperties", "labelName": "W700JobPropertiesAllProperties", "type": "AutoCheck", "status": true, "lasttransdate": "", "folderstructure": "", "missingfolder": "", "permissions": null, "count": 0 }, { "DisplayName": "W700JobProperties AgentId", "labelName": "W700JobPropertiesAgentId", "type": "AutoCheck", "status": true, "lasttransdate": "", "folderstructure": "", "missingfolder": "", "permissions": null, "count": 0 }, { "DisplayName": "W700JobProperties Agent API Key", "labelName": "W700JobPropertiesAgentAPIKey", "type": "AutoCheck", "status": true, "lasttransdate": "", "folderstructure": "", "missingfolder": "", "permissions": null, "count": 0 }, { "DisplayName": "W700JobProperties CaseURL", "labelName": "W700JobPropertiesCaseURL", "type": "AutoCheck", "status": true, "lasttransdate": "", "folderstructure": "", "missingfolder": "", "permissions": null, "count": 0 }, { "DisplayName": "W700JobProperties ConfigURL", "labelName": "W700JobPropertiesConfigURL", "type": "AutoCheck", "status": true, "lasttransdate": "", "folderstructure": "", "missingfolder": "", "permissions": null, "count": 0 }, { "DisplayName": "INTJob Last Run Time", "labelName": "INTJobLastJobRunTime", "type": "AutoCheck", "status": true, "lasttransdate": "06-01-2024 10:32:17", "folderstructure": "", "missingfolder": "", "permissions": null, "count": 0 }, { "DisplayName": "INTJob Next Run Time", "labelName": "INTJobNextJobRunTime", "type": "AutoCheck", "status": true, "lasttransdate": "06-01-2024 10:31:41", "folderstructure": "", "missingfolder": "", "permissions": null, "count": 0 }, { "DisplayName": "W700Circuit Config URL", "labelName": "W700CircuitConfigURL", "type": "AutoCheck", "status": true, "lasttransdate": "", "folderstructure": "", "missingfolder": "", "permissions": null, "count": 0 }, { "DisplayName": "W700Circuit GetOutBound XMl URL", "labelName": "W700CircuitGetOutBoundXmlURL", "type": "AutoCheck", "status": true, "lasttransdate": "", "folderstructure": "", "missingfolder": "", "permissions": null, "count": 0 }, { "DisplayName": "W700 file Check - DB connection properties", "labelName": "DBConnection", "type": "ManualCheck", "status": false, "lasttransdate": "", "folderstructure": "", "missingfolder": "", "permissions": null, "count": 0 }, { "DisplayName": "Windows Serive Stopped", "labelName": "WindowsService", "type": "ManualCheck", "status": false, "lasttransdate": "", "folderstructure": "", "missingfolder": "", "permissions": null, "count": 0 }], "status": "Failed" }, { "Header": "VA-FTP", "SequenceNumber": 3, "LableValue": [{ "DisplayName": "Last FTP File drop", "labelName": "Tranactionactions", "type": "AutoCheck", "status": false, "lasttransdate": "", "folderstructure": "", "missingfolder": "", "permissions": "", "count": 0 }, { "DisplayName": "Last Archived Transaction", "labelName": "Archive", "type": "AutoCheck", "status": false, "lasttransdate": "", "folderstructure": "", "missingfolder": "", "permissions": "", "count": 0 }, { "DisplayName": "Folders and Permissions", "labelName": "FolderCheck", "type": "AutoCheck", "status": true, "lasttransdate": "", "folderstructure": "ack,archive,error,ignore,progress", "missingfolder": null, "permissions": null, "count": 0 }, { "DisplayName": "Connectivity", "labelName": "Connectivity", "type": "AutoCheck", "status": true, "lasttransdate": "", "folderstructure": "", "missingfolder": "", "permissions": null, "count": 0 }, { "DisplayName": "Valid Credentials", "labelName": "Invalidcredentials", "type": "AutoCheck", "status": true, "lasttransdate": "", "folderstructure": "", "missingfolder": "", "permissions": null, "count": 0 }, { "DisplayName": "FTP User Permissions", "labelName": "Permission", "type": "AutoCheck", "status": true, "lasttransdate": "", "folderstructure": "", "missingfolder": "", "permissions": "download, upload", "count": 0 }, { "DisplayName": "IP Whitelisting", "labelName": "", "type": "ManualCheck", "status": false, "lasttransdate": "", "folderstructure": "", "missingfolder": "", "permissions": null, "count": 0 }, { "DisplayName": "FTP User - Active Password", "labelName": "", "type": "ManualCheck", "status": false, "lasttransdate": "", "folderstructure": "", "missingfolder": "", "permissions": null, "count": 0 }, { "DisplayName": "File Server - Folders and Permissions", "labelName": "", "type": "ManualCheck", "status": false, "lasttransdate": "", "folderstructure": "", "missingfolder": "", "permissions": null, "count": 0 }, { "DisplayName": "Valid FTP License", "labelName": "", "type": "ManualCheck", "status": false, "lasttransdate": "", "folderstructure": "", "missingfolder": "", "permissions": null, "count": 0 }, { "DisplayName": "Compatible TLS Version", "labelName": "", "type": "ManualCheck", "status": false, "lasttransdate": "", "folderstructure": "", "missingfolder": "", "permissions": null, "count": 0 }, { "DisplayName": "Pending Files to be processed", "labelName": "PendingFile", "type": "AutoCheck", "status": true, "lasttransdate": "", "folderstructure": "", "missingfolder": "", "permissions": null, "count": 0 }], "status": "Failed" }]
  constructor(private ngxUiLoaderService: NgxUiLoaderService,
    private toastr: ToastrService, public service: CommonService, public datepipe: DatePipe) { }


  ngOnChanges() {
    if(this.interfaceData['pipeLineDetails']!=undefined)
    {
      this.uniqueId=this.interfaceData['pipeLineDetails'][0]['UniqueID'];
      this.buildSeqData(this.interfaceData);
    }else{
      this.uniqueId=this.interfaceData.UniqueID;
      this.getpipelinedetails();
    }
  }

  getseqdata(value: string) {
    this.seqdataarr = [];
    this.selectedSeqName = value
    let seqdata = this.connseqdatalist.length > 0 ? this.connseqdatalist.filter(V => V['Name'] == value) : [];
    if (seqdata.length > 0) {
      let data = []
      seqdata.forEach((V, index) => {
        let obj = {}
        obj['Details' + (index + 1)] = [...V['Data']]
        data.push(obj);
      });

      this.seqdataarr.push({
        "Name": seqdata[0]['Name'],
        "Data": data
      });

    }
  }

  vbdiagnostic() {
    let obj = {
      "AgentId": this.pipeLineDetails['SourceAgentid'],
      "JobId": this.jobid.length > 0 && (this.jobid[0]['Value'] != undefined || this.jobid[0]['Value'] != null) ? this.jobid[0]['Value'] : '',
      "RouteId": this.pipeLineDetails['Id'],
      "UserId": JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid']
    }
    this.ngxUiLoaderService.start();
    this.service.getvbdiagnostic(JSON.stringify(obj)).subscribe((data) => {
      if (data["status"] == "success") {
        let vburl = data["responsebody"];
        let params = `width=1000,height=500,left=250,top=150`;
        open(vburl, 'VBDiagnoistic', params);
      }
      this.ngxUiLoaderService.stop();
    }), error => {
      this.toastr.error("No data found", "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      this.ngxUiLoaderService.stop();
    };
  }

  getdiagnostics() {
    if (this.connseqdatalist != undefined && this.DiagnosticList != undefined) {
      if (this.connseqdatalist.length > 0 && this.DiagnosticList.length > 0) {
        for (let index = 0; index < this.connseqdatalist.length; index++) {
          for (let i = 0; i < this.DiagnosticList.length; i++) {
            if (this.connseqdatalist[index]['Name'] == this.DiagnosticList[i]['Header']) {
              this.connseqdatalist[index]['status'] = this.DiagnosticList[i]['status']
            }
          }
        }
      }
    }
  }

  isviewpassword: boolean
  viewpassword() {

    if (this.isviewpassword) {
      this.service.auditsave("Add", "", "Viewed FTP password for pipeline :- " + this.pipeLineDetails['DisplayName'], "Pipeline", this.uniqueId, "Viewed Password (CIIS)");
    }
  }

  copyToClip(event: any, message) {
    if (event != '') {
      copyToClipboard(event);
      this.toastr.success(message + " " + 'Copied', "", {
        timeOut: 500,
        positionClass: 'toast-bottom-right'
      });
    }
  }

  getpipelinedetails() {
    this.ngxUiLoaderService.start();
    this.service.GetPipeleDetailsByUniqueID(this.uniqueId).subscribe((data) => {
      if (data['status'].toLowerCase() == 'success' && (data['statusmessage'] == null || data['statusmessage'].toLowerCase() != 'no data found')) {
        this.ishide = false
        let interfacedetails = JSON.parse(data['responsebody']);
        this.ngxUiLoaderService.start();
        this.buildSeqData(interfacedetails);
        //this.getsuccessmsglist('');
      }
      else {
        this.toastr.error("Unable to fetch pipeline details", "", {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        });
      }
    }), error => {
      this.toastr.error("Unable to fetch pipeline details", "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      this.ngxUiLoaderService.stop();
    }
  }

  buildSeqData(interfacedetails){
    this.pipeLineDetails = interfacedetails['pipeLineDetails'][0];
    this.getpendingfilesndiagnostics(this.pipeLineDetails['Id'],this.pipeLineDetails['SourceAgentid']);
    interfacedetails['connectivityDetails']['sequenceDataList'] != null && interfacedetails['connectivityDetails']['sequenceDataList'][0] != undefined ? this.sequence = interfacedetails['connectivityDetails']['sequenceDataList'] : this.sequence = [];
    this.connseqdatalist = [];
    if (this.sequence.length > 0) {
      let obj = {}
      this.sequence.forEach(V => {

        let backupSeq = JSON.parse(
          JSON.stringify(
            interfacedetails['connectivityDetails']['connectivityData'] != null
              ? interfacedetails['connectivityDetails']['connectivityData']
              : []
          )
        );
        if (this.connseqdatalist.length > 0) {
          this.connseqdatalist.forEach(X => {
            backupSeq = backupSeq.filter(element => element['TypeName'] !== X['Name']);
          })
        }
        if (backupSeq.length > 0) {
          let flag = 1;
          backupSeq.forEach(X => {
            if (X['Name'] == V['TypeName']) {
              if (flag) {
                obj = {
                  'Name': 'Description',
                  'Value': X['Description']
                }
                X['Data'].push(obj)
              }
              if (X['Name'] == 'VA-VBJOBS') {
                obj = {
                  'Name': 'VB Diagnostics',
                  'Value': 'Run'
                }
                X['Data'].unshift(obj);
                this.jobid = X['Data'].filter(element => element['Name'].toLowerCase() == 'jobid');
              }
              flag = 0
              obj = {
                'Name': V["TypeName"],
                'Data': X['Data'].map(item => ({
                  'Name': item['Name'].replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, match => match.toUpperCase()).replace('.', ''),
                  'Value': item['Value']
                })) 
              };
              this.connseqdatalist.push(obj)
            }
          });
        }
      })
    }
    this.connseqdatalist.length > 0 ? this.getseqdata(this.connseqdatalist[0]['Name']) : this.sequence.length > 0 ? this.getseqdata(this.sequence[0]['TypeName']):'';
    if (this.interfaceData.Isdiagnostics == true) {
      this.showdiagnostics = true
      this.getdiagnostics();
    }
  }
  getpendingfilesndiagnostics(rid,sourceagentid) {
    this.pendingfiledate = this.datesplit((this.datepipe.transform(new Date(), 'dd-MM-yyyy')).toString());
    this.ngxUiLoaderService.start();
    this.service.GetStatistics(rid,sourceagentid).subscribe(data => {
      this.ngxUiLoaderService.stop();
      if (data.length > 0) {
        let backupSeq = JSON.parse(JSON.stringify(this.sequence));
        data.forEach(V => {
          if (V['Header'].toLowerCase().includes('ftp') || V['Header'].toLowerCase().includes('vpn')) {
            V['LableValue'].forEach(X => {
              if ((X['labelName'].toLowerCase()) == 'pendingfile') {
                this.pendingfilecount = X['count'];
                let obj={
                  pendingfiledate:this.pendingfiledate,
                  pendingfilecount:this.pendingfilecount
                }
                this.filecountemit.emit(obj);
              }
            });
          }
          this.checkStatus(V);
          backupSeq = backupSeq.filter(X => X['TypeName'] !== V['Header']);
        });
        this.DiagnosticList = []
        this.DiagnosticList = data;
        if (backupSeq.length > 0) {
          backupSeq.forEach(V => {
            let obj = {
              "Header": V['TypeName'],
              "SequenceNumber": parseInt(V['Id']),
              "LableValue": [],
              "status": "default"
            }
            this.DiagnosticList.splice(V['Id'] - 1, 0, obj);
          })
        }
      }
    },
      (error) => {
        console.error();
        this.ngxUiLoaderService.stop();
        this.service.copyableToastError(error.statusText);
      }
    )
  }
  checkStatus(connectivity: any) {
    if (connectivity !== undefined) {
      let val = connectivity.LableValue.filter(
        (value) => value.status === false
      );
      if (val.length > 0) {
        connectivity["status"] = "Failed";
      } else {
        connectivity["status"] = "Success";
      }
    }
  }
  datesplit(value) {
    if (value !== undefined) {
      value = value.split(" ")[0]
      if (value.includes("-")) {
        value = value.split("-")
        return value[1] + "/" + value[0] + "/" + value[2]
      }
      else if (value.includes("/")) {
        value = value.split("/")
        return value[1] + "/" + value[0] + "/" + value[2]
      }
    }
  }
}
